export interface IOAuthClient {
  clientId: string;
  clientName: string;
  logoUri?: string;
  clientUri?: string;
  tosUri?: string;
  policyUri?: string;
}

export interface IOAuthAuthorizeParams {
  response_type: string;
  client_id: string;
  redirect_uri: string;
  scope?: string;
  state?: string;
  code_challenge?: string;
  code_challenge_method?: string;
}

export interface IOAuthAuthorizeResponse {
  client: IOAuthClient;
  scopes: string[];
  redirect_uri: string;
  state?: string;
  code_challenge?: string;
  code_challenge_method?: string;
}

export interface IOAuthAuthorizeSubmit {
  client_id: string;
  redirect_uri: string;
  scope?: string;
  state?: string;
  code_challenge?: string;
  code_challenge_method?: string;
  approved: boolean;
}

export interface IOAuthRedirectResponse {
  redirect_uri: string;
}

export interface IOAuthError {
  error: string;
  error_description?: string;
  state?: string;
}

export const OAUTH_SCOPES_DISPLAY: Record<string, string> = {
  profile: "View your profile information",
  email: "View your email address",
  invoices: "Access your invoices",
  payments: "View your payment information",
  accounts: "Access your bank account information",
  collaborators: "View your collaborators",
  documents: "Access your documents",
  tax: "View your tax information",
  openid: "Authenticate using your identity"
};

export const OAUTH_SESSION_KEY = "oauth_authorize_params";
